import {
  AbstractGitEntityState,
  AbstractStoreModel,
  AbstractStoreModelWithChildren,
  AbstractStoreModelWithParents,
} from '@y42/feature/git/state';
import { Y42MetadataGitModel } from '@y42/feature/json-schema';
import { JobStoreModel, JobUIModel, JobbableUIModel } from '@y42/job';
import { ImpexStoreModel } from '../impex/impex.model';

export interface ImpexChildSettingsModel {
  $schema: string;
}

export class ImpexChildStoreModel<Settings extends ImpexChildSettingsModel = ImpexChildSettingsModel>
  extends Y42MetadataGitModel
  implements AbstractStoreModelWithChildren, AbstractStoreModelWithParents
{
  constructor(model: ImpexChildStoreModel<Settings>) {
    super(model);
    this.$name = model.$name;
    this.$path = model.$path;
    this.$parent = model.$parent;
    this.$level = model.$level;
    this.$children = model.$children || [];
    this.$parentFolders = model.$parentFolders || [];

    this.name = model.name;
    this.settings = model.settings;
  }

  $name: string;
  $path: string;
  $parent: string;
  $level: number;
  $children: Array<JobStoreModel['request_id']>;
  $parentFolders: Array<ImpexStoreModel['$name']>;

  settings?: Settings;
}

export interface ImpexChildUIModel<
  Settings extends ImpexChildSettingsModel = ImpexChildSettingsModel,
  JobModel extends JobUIModel = JobUIModel,
> extends JobbableUIModel<JobModel> {
  settings?: Settings;
}

export interface ImpexChildState<T extends AbstractStoreModel = AbstractStoreModel, UIState = object>
  extends AbstractGitEntityState<T, UIState> {}
